import { z } from 'zod/v4';
export const Fda510kSubmissionDbSearchInputSchema = z.object({
    productCode: z.string().optional(),
    device510kNumber: z.string().optional(),
    deviceName: z.string().optional(),
    applicantName: z.string().optional(),
    limit: z.number().min(1).max(500).default(500),
    search_type: z.enum(['records', 'count']).default('records'),
    count_field: z
        .enum([
        'product_code.exact',
        'decision_code.exact',
        'device_name.exact',
        'applicant.exact',
    ])
        .default('product_code.exact'),
});
export const Fda510kSubmissionDbSearchOutputSchema = z.object({
    meta: z
        .object({
        total: z.number().optional(),
        limit: z.number().optional(),
        skip: z.number().optional(),
    })
        .optional(),
    submissions: z
        .array(z.object({
        productCode: z.string().nullish(),
        device510kNumber: z.string().nullish(),
        deviceName: z.string().nullish(),
        applicantName: z.string().nullish(),
        deviceNameLink: z.string().nullish(),
        decisionDate: z.string().nullish(),
        decision: z.string().nullish(),
        regulationNumber: z.string().nullish(),
        dateReceived: z.string().nullish(),
    }))
        .optional(),
    count_results: z
        .array(z.object({
        term: z.string(),
        count: z.number(),
    }))
        .optional(),
    search_query_built: z.string().optional(),
    search_criteria: z
        .object({
        productCode: z.string().optional(),
        device510kNumber: z.string().optional(),
        deviceName: z.string().optional(),
        applicantName: z.string().optional(),
    })
        .optional(),
    api_url: z.string().optional(),
});
//# sourceMappingURL=fda510ksubmission-db-search.js.map